<template>
  <div class="activityHome">
    <keep-alive :exclude="['personalVote1Detail',
                          'personalVote2Detail',
                          ]">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import {app} from "../network/app/app";
export default {
  name: 'LiveAct',
  created() {
    app.disable()
  }
}
</script>

<style scoped>
</style>
